module.exports = __webpack_public_path__ + "CG.png?82ab35233fd95ac5a08173f0b304e46f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/CG.png
// module id = 337
// module chunks = 0